import React from "react";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import Logo from '../Asset/Logo-Hotel-Hub.png';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-8">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between mb-6 space-y-4 md:space-y-0">
          {/* Logo */}
          <img
            src={Logo}
            alt="Logo"
            className="h-8 w-8 rounded-full object-cover"
          />
          {/* Social Links */}
          <div className="flex space-x-4 text-gray-300">
            <a href="#" className="hover:text-blue-400 transition-colors">
              <FaFacebook size={20} />
            </a>
            <a href="#" className="hover:text-blue-400 transition-colors">
              <FaTwitter size={20} />
            </a>
            <a href="#" className="hover:text-blue-400 transition-colors">
              <FaInstagram size={20} />
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center text-gray-500 text-sm">
          &copy; {year} HOTEL-HUB. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
